import { useLocation, Link } from "wouter-preact"
import { api_fetch } from "../api/client.tsx"
import { useFormState } from "@/components/form/form_state.tsx"
import { CenterColumnContainer } from "../components/LoginScreen.tsx"

import { Button } from "@/components/ui/button.tsx"
import { Logo } from "../app/logo.tsx"
import { Form } from "@/components/form/Form.tsx"
import { EmailInput } from "@/components/form/Input.tsx"

export function ForgotPassword() {
  const [, setLocation] = useLocation()
  const form = useFormState({
    email: "",
  })

  async function onSubmit() {
    const res = await api_fetch("/auth/forgot_password", {
      body: form.form_data,
    })
    if (!res.ok) {
      form.set_form_errors([res.error.message])
      return
    }
    form.set_form_success("Check your email for a password reset link!")
  }

  return (
    <CenterColumnContainer title="Reset your password" logo={<Logo />}>
      <Form class="space-y-6" onSubmit={onSubmit} alerts={form.form_alerts}>
        <EmailInput label="Email address" required={true} bind={form.email} />
        <Button type="submit" className="w-full" variant="tertiary">
          Send Reset Link
        </Button>
      </Form>
      <div class="text-center mt-4">
        <Link to="/login" class="text-sm text-gray-600 hover:text-gray-900">
          Back to login
        </Link>
      </div>
    </CenterColumnContainer>
  )
}
